require('./bootstrap');

// https://github.com/mattboldt/typed.js
window.Typed = require('typed.js');

import Vue from 'vue';
/**
 * Feather Icons
 * =============
 * https://feathericons.com/
 */
 const feather = require('feather-icons');
 feather.replace({ width: '', height: '' });


/**
 * Photoswipe
 * ==========
 * https://github.com/dimsemenov/PhotoSwipe
 */
 window.PhotoSwipe = require('photoswipe');
 window.PhotoSwipeUI_Default = require('./../../node_modules/photoswipe/src/js/ui/photoswipe-ui-default.js');

Vue.component('chat-component',  () => import('./components/ChatComponent.vue'));
Vue.component('chat-backend-component',  () => import('./components/ChatBackendComponent.vue'));

/**
 * Для скролла форм и прочего
 * ==========================
 */
window.ScrollMe = function (el = null, pos = 0, speed = 'slow')
{
    if (el) {
        pos = el.offset().top;
    }

    $('html, body').animate({ scrollTop: pos }, speed);
}

$(document).on('click', '.scroll-to-content', function() {
    ScrollMe($($(this).attr('data-el')));
});



function ScrollDetect()
{
    if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
        // $('.scroll-contactus').removeClass('d-none');
        $('.tradehouse_chat ').removeClass('d-none');
    } else {
        // $('.scroll-contactus').addClass('d-none');
        $('.tradehouse_chat ').addClass('d-none');
    }
}

$(document).on('click', '.scroll-contactus-btn', function() { ScrollMe($('.scroll-contactus-top')); });

window.onscroll = function() { ScrollDetect(); };
const app = new Vue({
    el: '#app',
});
